import { FooterWrapper } from "./styles";
import Logo from "../../assets/logos/2.svg";

const Footer = () => {
    return (
        <FooterWrapper id="contact" className="footer-1">
        <div className="main-footer widgets-dark">
          <div className="container typo-light">
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-4">
                <div className="widget subscribe no-box">
                  <h5 className="widget-title">
                    <img src={Logo} alt="logo" />
                    <span></span>
                  </h5>
                  <p className="footer-description">Backed by a team of experienced professionals, our strategic services meet the needs of all types and sizes of clients - from small startups to large firms - and deliver lasting changes with measurable growth.</p>
                </div>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-4 offset-md-4">
                <div className="widget no-box">
                  <h5 className="widget-title">
                    Contact Us<span></span>
                  </h5>

                  <p>
                    <a href="mailto:hello@digirepco.com" title="glorythemes">
                    hello@digirepco.com
                    </a>
                  </p>
                  <p>
                    <a href="tel:+447522079327" title="glorythemes">
                      +44 7522 079327
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className="footer-copyright">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <p>© 2022 by Digirep. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </FooterWrapper>
    )
}

export default Footer;